module.exports = __webpack_public_path__ + "img/document.02bfd16a.svg";